var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.495,
    height: 63.423,
    viewBox: "0 0 55.495 63.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(-19.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225228",
    "data-name": "Path 225228",
    d: "M23.293,0h33.68L74.824,17.782V59.459a3.964,3.964,0,0,1-3.964,3.964H23.293a3.964,3.964,0,0,1-3.964-3.964V3.964A3.964,3.964,0,0,1,23.293,0Z",
    fill: "#e2574c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225229",
    "data-name": "Path 225229",
    d: "M220.737,17.991H206.921a3.965,3.965,0,0,1-3.964-3.964V.193Z",
    transform: "translate(-145.97 -0.153)",
    fill: "#b53629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225230",
    "data-name": "Path 225230",
    d: "M113.811,137.7a1.152,1.152,0,0,0,0-2.281h-3.782a1.181,1.181,0,0,0-1.152,1.288V146c0,.829.472,1.288,1.11,1.288s1.108-.46,1.108-1.288v-2.551h2.287a1.074,1.074,0,0,0,1.064-1.157,1.054,1.054,0,0,0-1.064-1.126H111.1V137.7Zm-12.782-2.281H98.262a1.224,1.224,0,0,0-1.284,1.28v9.309a1.219,1.219,0,0,0,1.316,1.247h2.9A5.386,5.386,0,0,0,106.9,141.5C106.9,137.814,104.765,135.42,101.029,135.42Zm.133,9.541H99.475v-7.246H101c2.3,0,3.3,1.544,3.3,3.675C104.3,143.384,103.314,144.961,101.162,144.961ZM91.026,135.42H88.285a1.153,1.153,0,0,0-1.207,1.288V146a1.168,1.168,0,1,0,2.323,0v-2.713h1.718a3.753,3.753,0,0,0,3.871-3.918A3.8,3.8,0,0,0,91.026,135.42Zm-.046,5.688H89.4V137.6h1.58a1.761,1.761,0,0,1,0,3.506Z",
    transform: "translate(-53.855 -107.649)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.eff9da7dd001b0e290157cac45827535.svg";
export { ForwardRef as ReactComponent };